import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const messageApiService = {
    findForClaim,
    getEmailDocument,
    findWithoutClaim,
    linkToClaim,
    getEmailAddressList,
    sendEmail,
    getTagsForClaimMessage,
    findAttachmentsForClaim,
    setTagsForClaimMessage,
    getClaimsWithMessageUnread,
    previewEmail,
    getDocumentTypes,
    setDocumentTypeForAttachment,
    getClaimsWithMessageUncompleted,
    setMessageCompletedTask,
    setMessageDeleted
}

function findForClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/message/forclaim', payload)
}

function findAttachmentsForClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/message/attachmentsforclaim', payload)
}

function findWithoutClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/message/withoutclaim', payload)
}

function getEmailDocument(payload) {
    return axios.get(baseUrl + '/api/admin/v1/message/' + payload)
}

function linkToClaim(payload) {
    return axios.post(baseUrl + '/api/admin/v1/message/linktoclaim', payload)
}

function getEmailAddressList(payload) {
    return axios.get(baseUrl + '/api/admin/v1/message/emailaddresslist/' + payload)
}

function sendEmail(payload) {
    return axios.post(baseUrl + '/api/admin/v1/message/sendemail', payload)
}

function previewEmail(payload) {
    return axios.post(baseUrl + '/api/admin/v1/message/previewemail', payload)
}

function getTagsForClaimMessage({ claimId, messageId }) {
    return axios.get(`${baseUrl}/api/admin/v1/message/tags/${claimId}/${messageId}`)
}

function setTagsForClaimMessage(payload) {
    return axios.post(`${baseUrl}/api/admin/v1/message/tags/`, payload)
}

function getClaimsWithMessageUnread(payload) {
    return axios.post(`${baseUrl}/api/admin/v1/message/getclaimswithunread/`, payload)
}

function getDocumentTypes() {
    return axios.get(`${baseUrl}/api/admin/v1/document/gettypes/`)
}

function setDocumentTypeForAttachment(payload) {
    return axios.post(`${baseUrl}/api/admin/v1/message/setdocumenttypeforattachment/`, payload)
}

function getClaimsWithMessageUncompleted(payload) {
    return axios.post(`${baseUrl}/api/admin/v1/message/getclaimswithuncompleted/`, payload)
}

function setMessageCompletedTask(payload) {
    return axios.post(`${baseUrl}/api/admin/v1/message/setmessagetaskcomplete/`, payload)
}

function setMessageDeleted(payload) {
    return axios.post(`${baseUrl}/api/admin/v1/message/setmessagedeleted/`, payload)
}